{
  "fr": [
    {
      "question": "Pourquoi le site est en anglais ?",
      "response": "Nous développons nos services en anglais (pour la programmation c'est plus simple) et pour qu'Iziplay soit accessible au plus grand nombre."
    },
    {
      "question": "Que'est-ce que le mode privé ?",
      "response": "Le mode privé vous permet de ne pas communiquer avec nos serveurs et autres services tiers de la visualisation courante d'un film/épisode/porn. Par contre, le suivi n'est du coup, pas sauvegardé."
    },
    {
      "question": "Comment trier les films et les séries par genre ?",
      "response": "Pour trier les films et les séries par genre, vous pouvez écrire dans la barre de recherche : #horror, #comedy, #action, #adventure, #animation, #crime, #documentary, #drama, #family, #fantasy, #music, #mystery, #romance, #sci-fi, #tvmovie, #thriller, #war, #western"
    },
    {
      "question": "Pourquoi le film s'arrète tout seul toutes les 2 minutes ?",
      "response": "Cela signifie que le film est encore en cours de téléchargement. Il suffit de patienter, take a coffee ! ;)"
    },
    {
      "question": "Pourquoi les sous-titres sont décalés de l'image/du son ?",
      "response": "Vous pouvez selectionner d'autres sous-titres dans la même langue pour voir si un correspond. S'ils sont toujours décalés, regardez votre fichier dans VLC et utilisez les fonctions de synchronisation. Sinon, voir question suivante."
    },
    {
      "question": "Pourquoi mes sous-titres ont des fautes ?",
      "response": "Les textes des sous-titres ne dependent pas de nous, désolé. Mais si vous trouvez une super API, envoyez un ticket !"
    },
    {
      "question": "Pourquoi la liste des qualités pour mon épisode/film est vide ?",
      "response": "Le film n'est pas encore disponible, ou n'est pas assez connu pour être trouvé. Ajoutez-le dans la liste \"Voir plus tard\" pour ne pas l'oublier."
    },
    {
      "question": "Il manque l'image/le son sur mon fichier.",
      "response": "Envoyez-nous un ticket avec le titre du film et la qualité choisie."
    },
    {
      "question": "Quelle est la différence entre MP3, AAC, Lossless et Hi-Res Lossless ?",
      "response": "Le MP3 comme le AAC est un format compressé avec perte (certaines fréquences ont étées coupées pour réduire la taille du fichier), le AAC est plus récent et sa technologie permet de moins perdre de données. Le Lossless quant à lui, reproduit la qualité CD (44.1kHz/16bit jugé donc sans perte). Le Hi-Res Lossless est échantillonné sur au moins 24 bits (parfois en 48kHz) et est identifié comme qualité studio. Spoiler : dans la majorité des cas le AAC avec un bitrate > 190kbps est largement suffisant et l'écart avec le Lossless est inaudible sans oreilles éduquées."
    }
  ],
  "en": [
    {
      "question": "I don't understand why Iziplay is in english!",
      "response": "We're developing Iziplay in english to be more accessible"
    }
  ]
}
